/** 一些需要重复使用的菜单项名称 */
export enum MENU_LABEL {
  LEYOPAY = '结算系统',
  SETTLEMENT = '自助结算',
  VARITY = '我的品种'
}

/** 用于控制路由权限的角色大类名称（展示用新名；匹配须兼容旧名「摇钱树*」） */
export enum ROUTE_ROLE_TYPE_NAME {
  MONEY_TREE_ONLY = 'YQS供应商',
  FIRST_MONEY_BOTH = '首推供应商&YQS供应商'
}

const LEGACY_MONEY_TREE_ONLY = '摇钱树供应商'
const LEGACY_FIRST_MONEY_BOTH = '首推供应商&摇钱树供应商'

export function expandRoleTypeNames(names: string[] = []) {
  const set = new Set(names)
  names.forEach((n) => {
    if (n === ROUTE_ROLE_TYPE_NAME.MONEY_TREE_ONLY || n === LEGACY_MONEY_TREE_ONLY) {
      set.add(ROUTE_ROLE_TYPE_NAME.MONEY_TREE_ONLY)
      set.add(LEGACY_MONEY_TREE_ONLY)
    }
    if (n === ROUTE_ROLE_TYPE_NAME.FIRST_MONEY_BOTH || n === LEGACY_FIRST_MONEY_BOTH) {
      set.add(ROUTE_ROLE_TYPE_NAME.FIRST_MONEY_BOTH)
      set.add(LEGACY_FIRST_MONEY_BOTH)
    }
  })
  return set
}

export function isFirstMoneyBothMenuName(name: string) {
  return name === ROUTE_ROLE_TYPE_NAME.FIRST_MONEY_BOTH || name === LEGACY_FIRST_MONEY_BOTH
}

export function matchMenuOfRoleType(menuOfRoleType: string[] | undefined, roleTypeName: string) {
  if (!menuOfRoleType) return true
  return expandRoleTypeNames(menuOfRoleType).has(roleTypeName)
}
